import React from "react";

import { Line } from "src/shared/components";
import { ResultProps } from "./types";
import { useResult } from "./hooks";

export const Result = (props: ResultProps) => {
  const { getCupProps, getTimeProps, values } = useResult(props);
  return (
    <div className={values.styles.result}>
      <Line line={props.car.line} testId="p-line" />
      <img {...getCupProps()} />
      <div {...getTimeProps()}>
        <span>{values.sc}</span>
        <span>{values.ms}</span>
      </div>
    </div>
  );
};
